import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  employerTagsKey,
  updateEmployerTagsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useUpdateEmployertagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateEmployertags = ({
  setErrorText = () => { },
}: useUpdateEmployertagsProps) => {
  const client = useQueryClient();

  const { mutate: updateEmployertags, isLoading: isupdateEmployertagsLoading } =
    useMutation({
      mutationFn: (variables: {
        tag: string;
        tag_id: number;
      }) =>
        axiosInstance
          .post(updateEmployerTagsRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([employerTagsKey]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    updateEmployertags,
    isupdateEmployertagsLoading,
  };
};
